import { render, staticRenderFns } from "./Wallboard.vue?vue&type=template&id=356ddfa5&"
import script from "./Wallboard.vue?vue&type=script&lang=js&"
export * from "./Wallboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports